import { Box } from "@raca2022/uikit";
import styled from "styled-components";
import BgGb from "../../assets/img/Langding/BgGb.png";
import BgParalax from "../../assets/img/Langding/BgParalax.png";

export const BackgroundHome = styled(Box)`
  width: 100%;
  max-width: 1920px;
  margin: auto;
  background-image: url("${BgGb}");
  background-repeat: no-repeat;
  background-size: 190%;
  background-position: top center;
  min-height: 960px;
  position: relative;
  overflow-x: hidden;
  @media only screen and (min-width: 1921px) {
    :before {
      content: "";
      width: 200px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transform: translateX(-50%);
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      );
      z-index: 99;
    }
    :after {
      content: "";
      width: 200px;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(50%) rotateZ(180deg);
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      );
      z-index: 99;
    }
  }
`;
export const FloorParalax = styled(Box)`
  width: 100%;
  position: fixed;
  max-width: 1920px;
  padding: 0px 4vw;
  left: 50%;
  transform: translateX(-50%);
  top: 129px;
  height: 690px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("${BgParalax}");
  padding-top: 323px;
  z-index: 2;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 876px;
    flex-wrap: wrap;
    margin: auto;
    h1 {
      width: fit-content;
      font-weight: 800;
      font-size: 129.204px;
      line-height: 86%;
      font-family: PoppinsExtraBold;
    }
    p {
      font-weight: 600;
      font-size: 28px;
      line-height: 110%;
      color: #ffffff;
      padding-left: 13px;
      border-left: 2px solid #fff;
      margin-left: 20px;
    }
  }
  @media only screen and (min-width: 1920px) {
    padding: 323px 80px 0px;
  }
  @media only screen and (max-width: 1024px) {
    padding: 31.5vw 4vw 0px;
    height: 67.3vw;
    background-position: 34% center;
    div{
      h1{
        font-size: 12.5vw;
      }
      p{
        font-size: 2.7vw;
      }
    }
  }
`;
